import { React } from "react";
import { FormGroup, Input, Label, Row } from "reactstrap";
import pizzalabel from "assets/img/pizzalabel.svg";

const ItemsDetail = ({ data, selectedItem, setSelectedItem, bgColor }) => {
  const handleChange = (size, price) => {
    setSelectedItem((prev) => {
      const newPrice = Number(price);
      const addonsTotal = prev.addons.reduce(
        (sum, addon) => sum + addon.price * addon.quantity,
        0
      );

      return {
        ...prev,
        size,
        price: newPrice,
        totalPrice: newPrice * prev.quantity + addonsTotal,
      };
    });
  };

  return (
    <div className="mx-2 d-flex flex-column justify-content-start align-items-start">
      <h3 className="fs--18 fw--600 mb-0 d-flex flex-column normal-heading">
        Size
      </h3>
      <div className="size-container w-100">
        {data &&
          data.map((item, index) => {
            const isChecked = selectedItem.size === item.size;
            return (
              <Row
                className="d-flex justify-content-between align-items-center top_cards__sizes border-bottom px-0 ml-2 mr-2"
                key={index}
              >
                <div className="d-flex justify-content-center align-items-center py-2">
                  <FormGroup check className="mx-0">
                    <Label check>
                      <Input
                        type="radio"
                        name="size"
                        value={item.size}
                        checked={isChecked}
                        onChange={() => handleChange(item.size, item.price)}
                        style={{
                          "--accent-color": bgColor,
                        }}
                      />
                      <img
                        alt="image"
                        src={pizzalabel}
                        width={25}
                        className="mx-2"
                      />
                    </Label>
                  </FormGroup>
                  <h5 className="mb-0 fs--14 fw--400 text-capitalize normal-heading">
                    {item?.size}
                  </h5>
                </div>
                <h4 className="mb-0 fs--14 fw--400">
                  {selectedItem?.currency}&nbsp;{item.price}
                </h4>
              </Row>
            );
          })}
      </div>
    </div>
  );
};

export default ItemsDetail;
